// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__yxeBb","skeleton-shimmer":"Skeleton_skeleton-shimmer__A+6Vo","static":"Skeleton_static__EodSE"};